import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
// import { useAuthStore } from './stores/auth'
import './assets/styles/global.css'
import { createI18n } from 'vue-i18n'
// import zhCN from './locales/zh-CN'
// import enUS from './locales/en-US'
// import koKR from './locales/ko-KR'
// import jaJP from './locales/ja-JP'
// import frFR from './locales/fr-FR'
// import deDE from './locales/de-DE'
// import { initLanguage } from './composables/useI18n'

// console.log('main.ts loaded')

// 添加全局错误处理
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

// 辅助函数：延迟执行
// function sleep(ms: number): Promise<void> {
//   return new Promise(resolve => setTimeout(resolve, ms))
// }

// 创建 Pinia 实例
const pinia = createPinia()

// 创建 i18n 实例（初始只加载中文）
export const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh-CN', // 设置默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages: {} // 初始为空，按需加载
})

const app = createApp(App)

console.log('app created, installing plugins...')

// 按正确顺序安装插件
app.use(pinia)
app.use(router)
app.use(i18n)

console.log('plugins installed, mounting app...')

// 预加载默认语言包
async function loadDefaultLocale() {
  try {
    const defaultMessages = await import('./locales/zh-CN')
    i18n.global.setLocaleMessage('zh-CN', defaultMessages.default)
    // console.log('✅ 默认语言包加载完成')
    return true
  } catch (error) {
    console.error('❌ 加载默认语言包失败:', error)
    // 即使加载失败也返回 true，让应用可以继续启动
    return true
  }
}

// 确保语言包加载完成后再挂载应用
loadDefaultLocale()
  .then(() => {
    app.mount('#app')
    console.log('✅ 应用挂载成功')
    
    // 动态更新 meta 标签（在应用挂载后）
    updateMetaTags()
  })
  .catch((error) => {
    console.error('❌ 应用初始化失败:', error)
  })

/**
 * 动态更新页面的 meta 标签和标题
 * 从语言文件中读取翻译内容
 */
function updateMetaTags() {
  const currentLang = (router.currentRoute.value.params.lang as string) || 'zh'
  const langCode = currentLang === 'zh' ? 'zh-CN' : currentLang
  
  // 等待 i18n 加载完成，确保翻译内容可用
  // sleep(300)
  
  // 获取翻译内容
  const siteName = i18n.global.t('footer.company.name') || '安徽艾尔工程建设有限公司'
  // const englishName = i18n.global.t('footer.company.englishName') || 'ANHUI AIR ENGINEERING & CONSTRUCTION CO., LTD.'
  const description = i18n.global.t('footer.company.description') || '专业空分工程施工与工业模块制造，国家高新技术企业，致力于为客户提供最优质的工程解决方案'
  const keywords = i18n.global.t('seo.keywords') || '空分工程，工业模块，压力容器，ASME 认证，工程建设'
  
  // 更新 title
  document.title = `${siteName}`
  
  // 更新 meta description
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.setAttribute('content', description)
  }
  
  // 更新 meta keywords
  const metaKeywords = document.querySelector('meta[name="keywords"]')
  if (metaKeywords) {
    metaKeywords.setAttribute('content', keywords)
  }
  
  // 更新 Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) {
    ogTitle.setAttribute('content', siteName)
  }
  
  const ogDescription = document.querySelector('meta[property="og:description"]')
  if (ogDescription) {
    ogDescription.setAttribute('content', description)
  }
  
  // 更新 html lang 属性
  document.documentElement.lang = langCode
  
  // console.log('[Main] Meta tags updated with language:', langCode)
}

// 监听 i18n locale 变化，更新 meta 标签
import { watch } from 'vue'
watch(() => i18n.global.locale, (newLocale) => {
  console.log('[Main] i18n locale changed to:', newLocale)
  updateMetaTags()
})

// 监听路由变化，当语言切换时更新 meta 标签
router.afterEach((to, from) => {
  if (to.params.lang !== from.params.lang) {
    // 等待 i18n 语言包加载完成后再更新 meta 标签
    setTimeout(() => {
      updateMetaTags()
    }, 500) // 与 updateMetaTags 内部的 sleep 保持一致
  }
})

